import { useLagging } from '@crocodille/common';
import NavigationDrawer from './navigation-drawer/navigation-drawer';
import NavigationSidebar from './navigation-sidebar/navigation-sidebar';
import { useMedia } from '@hooks/use-media';
import React from 'react';

export interface AppLayoutNavigationProps {
  readonly open: boolean;
}

/**
 * Switches between two components, according to screen size.
 */
const AppLayoutNavigation: React.FC<
  React.PropsWithChildren<AppLayoutNavigationProps>
> = ({ children, open }) => {
  const isDrawer = useMedia('layout-with-drawer', true);
  const isRendered = useLagging(open || !isDrawer, (value) => value === true);

  if (!isRendered) {
    return null;
  }

  return isDrawer ? (
    <NavigationDrawer open={open}>{children}</NavigationDrawer>
  ) : (
    <NavigationSidebar open={open}>{children}</NavigationSidebar>
  );
};

export default AppLayoutNavigation;
